export const TRADING_KEYS = {
  ACTIVE_TRADING_ACCOUNT: 'activeTradingAccount',
  TAB: 'activeTradingAccountTab',
};
